<ls-section-band
  data-testid="page-latest"
  [eyebrow]="'HOME.LATEST.EYEBROW' | translate"
  [heading]="'HOME.LATEST.H2' | translate"
  [moreLabel]="'SECTIONS.LISTS.BACK_HOME' | translate"
  [moreLink]="['/', lang()]"
  [moreBack]="true"
  moreTestId="link-back-home">
  <ls-lyric-list-section mode="latest" [paginate]="true" [pageSize]="20" />
</ls-section-band>
